import { render, staticRenderFns } from "./ReceivedContactList.vue?vue&type=template&id=62e309d3&scoped=true&"
import script from "./ReceivedContactList.vue?vue&type=script&lang=js&"
export * from "./ReceivedContactList.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedContactList.vue?vue&type=style&index=0&id=62e309d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e309d3",
  null
  
)

export default component.exports